import React from 'react'
import { connect } from 'react-redux'
import { logInAction } from '../../../actions/shopifyActions'
import { getStatusAction } from '../../../actions/appActions'
import Loader from '../../loaders'
import routes from '../../router/routes'
import { appEnabled } from '../../../server/common'

class Component extends React.Component {
    getStatus = () => {
        this.props
            .getStatusAction(this.props.history)
            .then((status) => {
                if (appEnabled(status)) {
                    this.props.history.push(routes.orders.path)
                    this.setState({ ready: true })
                }
            })
            .catch((error) => {
                if (error.additionalData)
                    window.showDialog({ message: error.additionalData }, false)
                else window.showDialog(error, false)
            })
    }

    authenticate = () => {
        this.props
            .logInAction(this.props.location.search)
            .then(() => this.getStatus())
            .catch((error) => window.showDialog(error, false))
    }

    componentDidMount() {
        this.authenticate()
    }

    render() {
        return <Loader />
    }
}

const mapDispatchToProps = { logInAction, getStatusAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
